import React, { useState, useEffect, useCallback, useRef } from 'react';
import Logo from "../images/logo.svg";
import Sidebar from '../component/Sidebar';
import { SelectPicker, DatePicker, Dropdown, Placeholder, Whisper, Button, Popover, Message, useToaster, Tooltip, Input, Modal } from "rsuite";
import 'rsuite/SelectPicker/styles/index.css';
import { Link } from "react-router-dom";
import 'aos/dist/aos.css';
import AOS from 'aos';
import debounce from 'lodash.debounce';
import IconDelete from "../images/deleteBG.svg";
import IconInfo from "../images/IconErrorInfo.svg";
import IconError from "../images/IconError.svg";
import IconCheckError from "../images/IconCheckError.svg";

import icon_Asc from "../images/Asc.svg";
import icon_Desc from "../images/Desc.svg";

import icon1_Asc from "../images/Asc.svg";
import icon1_Desc from "../images/Desc.svg";

import icon2_Asc from "../images/Asc.svg";
import icon2_Desc from "../images/Desc.svg";

import icon3_Asc from "../images/Asc.svg";
import icon3_Desc from "../images/Desc.svg";

import iconArrowDrop from "../images/iconArrowDrop.svg";
import Icon_info from "../images/iconInfo.svg";
import mockData from "../sample/mockData.json";

import iconUS from "../images/US.svg";
import iconIN from "../images/in.svg";
import iconsaudi from "../images/saudi.svg";
import iconPakistan from "../images/pakistan.svg";
import iconUAE from "../images/UAE.svg";
import iconQatar from "../images/qatar.svg";
import iconkuwait from "../images/kuwait.svg";
import iconbahrain from "../images/bahrain.svg";

import iconwhatsapp from "../images/whatsapp.svg";
import icongmail from "../images/gmail.svg";
import iconphonecall from "../images/phone-call.svg";
import iconSMS from "../images/sms.svg";


function InvestmentList() {

  const [tabName, setTabName] = useState('Investment Transaction ');

  useEffect(() => {
    document.title = tabName;
  }, [tabName]);

  const orderData = ['ASC', 'DESC'].map(
    item => ({ label: item, value: item })
  );

  const CBAStatus = ['Pass', 'Fail'].map(
    item => ({ label: item, value: item })
  );

  const statusData = [
    { label: 'Publish', value: true },
    { label: 'UnPublish', value: false },
    { label: 'Both', value: '' }
  ];

  useEffect(() => {
    AOS.init();
  }, []);

  const abortControllerRef = useRef(null);
  const [isLoading, setLoading] = useState(true); // State to manage loading state
  const apiEndPoint = process.env.REACT_APP_ETF_API_ENDPOINT;
  const apiEndPoint1 = process.env.REACT_APP_API_ENDPOINT;
  const frontEndLink = process.env.REACT_APP_MUSAFFA_LINK;
  const roleName = localStorage.getItem("novaRolename");
  const merlinJuniorAnalyst = process.env.REACT_APP_MERLIN_JUNIOR_ANALYST;
  const [pageRange, setPageRange] = useState("20");
  const [reportData, setReportData] = useState([]);
  const [reportCount, setReportCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [startPage, setStartPage] = useState(1);
  const [countryCode, setCountryCode] = useState("US");
  const [complianceId, setComplianceId] = useState("");
  const [cbaStatus, setCbaStatus] = useState("");

  const [orderBy, setOrderBy] = useState("total_holdings"); // default orderBy
  const [order, setOrder] = useState("DESC"); // default order

  const [statusId, setStatusId] = useState(0);
  const [searchInput, setSearchInput] = useState("");

  const [minValue, setMinValue] = useState("");
  const [maxValue, setMaxValue] = useState("");

  const [CMPTminValue, setCMPTMinValue] = useState("");
  const [CMPTmaxValue, setCMPTMaxValue] = useState("");

  const [NCMPTminValue, setNCMPTMinValue] = useState("");
  const [NCMPTmaxValue, setNCMPTMaxValue] = useState("");

  const [DBFTminValue, setDBFTMinValue] = useState("");
  const [DBFTmaxValue, setDBFTMaxValue] = useState("");

  const [IntrestminValue, setIntrestMinValue] = useState("");
  const [IntrestmaxValue, setIntrestMaxValue] = useState("");

  const [DEBTminValue, setDEBTMinValue] = useState("");
  const [DEBTmaxValue, setDEBTMaxValue] = useState("");

  const [countryData, setCountryData] = useState([]);
  const [complianceData, setComplianceData] = useState([]);

  const [selectedQuarter, setSelectedQuarter] = useState("");

  const userid = localStorage.getItem("novauserid");
  const progressStatus = process.env.REACT_APP_TASK_MANAGER_PROGRESS_Status;


  const [errorMessage, setErrorMessage] = useState('');
  const [messageType, setMessageType] = useState(null); // success, error, info
  const [assetClassData, setAssetClassData] = useState([]);
  const [searchAsset, setSearchAsset] = useState("Equity");

  const [isAscending, setIsAscending] = useState(false);
  const [isAscending1, setIsAscending1] = useState(true);
  const [isAscending2, setIsAscending2] = useState(true);


  const handleIconClick = (columnName) => {
    // Toggle between ascending and descending icons

    setOrderBy(columnName);

    switch (columnName) {
      case "total_holdings":
        setIsAscending(!isAscending);
        setOrder(isAscending ? "DESC" : "ASC");
        break;
      case "total_uncovered":
        setIsAscending2(!isAscending2);
        setOrder(isAscending2 ? "DESC" : "ASC");
        break;
      case "total_cover":
        setIsAscending1(!isAscending1);
        setOrder(isAscending1 ? "DESC" : "ASC");
        break;
      default:
        setIsAscending(!isAscending);
        setOrder(isAscending ? "DESC" : "ASC");
        break;
    }

  };

  const fetchGlobalReport = async () => {
    setLoading(true);

    try {

      const { status, message, count, data } = mockData.data;
      if (status === "success") {
        setLoading(false);
        setReportCount(count);
        console.log('RES :' + searchInput + ' : ' + JSON.stringify(data));
        setReportData(data);
      } else {
        console.error("Error: ", message);
      }
    } catch (error) {
      console.error("Error fetching mock data:", error.message);
      return false;
    }
  };


  const debouncedFetchGlobalReport = useCallback(
    debounce(() => {
      fetchGlobalReport();
    }, 1000),
    [searchInput, minValue, maxValue, NCMPTminValue, NCMPTmaxValue, CMPTminValue, CMPTmaxValue, DBFTminValue, DBFTmaxValue, IntrestminValue, IntrestmaxValue, DEBTminValue, DEBTmaxValue] // Only debounce on search input changes
  );

  useEffect(() => {
    debouncedFetchGlobalReport();
    return () => {
      debouncedFetchGlobalReport.cancel();
    };
  }, [searchInput, minValue, maxValue, NCMPTminValue, NCMPTmaxValue, CMPTminValue, CMPTmaxValue, DBFTminValue, DBFTmaxValue, IntrestminValue, IntrestmaxValue, DEBTminValue, DEBTmaxValue]);

  useEffect(() => {
    fetchGlobalReport();
  }, [currentPage, countryCode, complianceId, statusId, searchAsset, order, orderBy, pageRange, cbaStatus]); // Regular effect for other dependencies


  const handleSearch = (event) => {
    console.log(event.target.value);

    setSearchInput(event.target.value);
    setCurrentPage(1); // Reset to the first page for new search
  };


  const [customPaginationValue, setCustomPaginationValue] = useState("");

  // Debounced function to update the page number
  const debouncedSetPage = useCallback(
    debounce((page) => {
      setCurrentPage(page);
    }, 1000), // Delay of 500ms (half a second)
    []
  );

  const handlePaginationChange = (e) => {
    const value = (e.target.value == 0 ? 1 : e.target.value).toString();
    setCustomPaginationValue(value); // Update input value immediately for fast typing
    debouncedSetPage(Number(value)); // Trigger the debounced function
  };

  const handlePagelimit = (value) => {
    setCurrentPage(1);
    setCustomPaginationValue(1);
    setPageRange(value);
  };


  const renderPagination = () => {
    // Calculate total number of pages
    const totalPages = Math.ceil(reportCount / pageRange);

    // Show a default of 3 pages if the total pages are more than 3
    const pageNumbers = [];
    const visiblePageCount = 4; // Number of pages to show by default

    let startPage = currentPage - 1;
    let endPage = currentPage + 2;

    // Adjust pagination if total pages are less than the default
    if (totalPages <= visiblePageCount) {
      startPage = 1;
      endPage = totalPages;

    } else {

      // Ensure the pagination does not go out of bounds
      startPage = Math.max(1, startPage);
      endPage = Math.min(totalPages, endPage);
    }

    // Create page numbers to display based on current page
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return (
      <nav aria-label="..." id='pagination_row' style={{ alignItems: 'center', justifyContent: 'space-between', background: '#FFF', paddingTop: 0, paddingBottom: 0 }}>
        <div className='totalRecords'>
          Total Records :  {4}
        </div>
        <ul className="pagination" style={{ border: 0, background: 'none' }}>

          <li class="page-item" style={{ marginLeft: 10 }}>
            <SelectPicker onChange={handlePagelimit} cleanable={false}
              value={pageRange}
              placement="top" placeholder='Pages' data={PagingData} searchable={false} style={{ width: 85, height: 35, display: 'flex', alignItems: 'center', borderRadius: 5, border: '1px solid #A1B9ED' }} />
          </li>

          {/* Previous Page (Double Arrow) */}
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`} style={{ marginLeft: 10 }}>
            <a href="#" className="page-link" onClick={() => setCurrentPage(1)}>
              <i className="fa fa-angle-double-left"></i>
            </a>
          </li>

          {/* Previous Page (Single Arrow) */}
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
            <a href="#" className="page-link" onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}>
              <i className="fa fa-angle-left"></i>
            </a>
          </li>

          {/* Page numbers */}
          {pageNumbers.map(page => (
            <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
              <a
                className="page-link" href="#"
                onClick={() => setCurrentPage(page)} // Set the clicked page as the current page
              >
                {page}
              </a>
            </li>
          ))}

          {/* Next Page (Single Arrow) */}
          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
            <a href="#" className="page-link" onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}>
              <i className="fa fa-angle-right"></i>
            </a>
          </li>

          {/* Next Page (Double Arrow) */}
          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`} style={{ marginRight: 10 }}>
            <a href="#" className="page-link" onClick={() => setCurrentPage(totalPages)}>
              <i className="fa fa-angle-double-right"></i>
            </a>
          </li>

          {/* Go to Page */}
          <li className="page-item" style={{ marginLeft: 10, display: 'flex', alignItems: 'center', gap: 5 }}>
            <input
              type="text"
              placeholder="Go#"
              className="form-control"
              value={customPaginationValue}
              onChange={handlePaginationChange}
              onInput={(e) => {
                // Only allow numbers
                e.target.value = e.target.value.replace(/[^0-9]/g, '');
              }}

              style={{
                padding: '0px 10px',
                color: '#878787',
                fontSize: 16,
                borderRadius: 5,
                border: '1px solid #A1B9ED',
                width: 60,
                height: 35,
                textAlign: 'center'
              }}
            />
          </li>
        </ul>
      </nav>
    );
  };





  // PAGINATION
  const PagingData = ['10', '20', '50', '100'].map(
    item => ({ label: item, value: item })
  );

  const handleClearFilters = () => {
    setCurrentPage(1);
    setSearchInput("");
    setSearchAsset("");
    setCountryCode("");
    setStatusId("");
    setComplianceId("");
    setOrder("");
    setMinValue("");
    setMaxValue("");
    setCMPTMinValue("");
    setCMPTMaxValue("");
    setNCMPTMinValue("");
    setNCMPTMaxValue("");
    setDBFTMinValue("");
    setDBFTMaxValue("");
    setIntrestMinValue("");
    setIntrestMaxValue("");
    setDEBTMinValue("");
    setDEBTMaxValue("");
  };


  const handleAssetClass = (value) => {
    setSearchAsset(value);
    setCurrentPage(1); // Reset to the first page for new search
  };




  const handleCountryChange = (value) => {
    setCurrentPage(1);
    setCountryCode(value);
  };





  const handleStatusChange = (value) => {
    setStatusId(value);
  };

  const handleComplianceChange = (value) => {
    setCurrentPage(1);
    setComplianceId(value);
  };

  const handleCBAChange = (value) => {
    setCurrentPage(1);
    setCbaStatus(value);
  };

  const handleorderChange = (value) => {
    setCurrentPage(1);
    setOrder(value);
  };

  // Compliance List
  useEffect(() => {
    const fetchComplianceStatusList = async () => {
      const url = `${apiEndPoint1}/get_compliance_status`;
      const payload = {
        data: {
          user_id: userid // Replace with the actual user_id if dynamic
        }
      };

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const responseData = await response.json();
        const data = responseData.data; // Flatten the response

        const formattedComplianceStatusData = data.data.map((complaince) => ({
          label: complaince.name,
          value: complaince.id,
        }));

        setComplianceData(formattedComplianceStatusData);

      } catch (error) {
        console.log(error);
      }
    };

    fetchComplianceStatusList();
  }, []);




  const [openDeletePopover, setOpenDeletePopover] = useState(null);
  const [publishSymbol, setPublishSymbol] = useState("");
  // Function to handle checkbox click
  const handleCheckboxClick = (item) => {
    // Toggle the popover visibility for the specific item
    setPublishSymbol(item.Symbol)
    if (openDeletePopover === item.id) {
      setOpenDeletePopover(null); // Close the popover if it's already open
    } else {
      setOpenDeletePopover(item.id); // Open the popover
    }
  };

  // // Function to handle deletion confirmation
  // const handlePublishConfirm = (Symbol) => {


  //     console.log(`Publish report with Symbol: ${Symbol}`);
  //     setOpenDeletePopover(null); // Close the popover after confirmation
  // };

  const handlePublishConfirm = (item) => {
    // console.log(`Publish report with Symbol: ${Symbol}`);

    // Prepare the data to be sent in the API request
    const requestData = {
      data: {
        user_id: userid, // Replace with actual user_id if needed
        symbol: item.Symbol, // Use the symbol passed to the function
        publish: item.Published ? "false" : "true"
      }
    };



    setOpenDeletePopover(null); // Close the popover after confirmation
  };


  const handleCheckboxChange = (e, item) => {
    setPublishSymbol(item.Symbol)
    //e.stopPropagation(); // Prevents the event from bubbling up
    // Handle the checkbox change here
    // You can check e.target.checked to see if it's checked or unchecked
  };


  const [open, setOpen] = useState(false);
  const [CMPTopen, setCMPTOpen] = useState(false);
  const [NCMPTopen, setNCMPTOpen] = useState(false);
  const [DBFTopen, setDBFTOpen] = useState(false);
  const [Intrestopen, setIntrestOpen] = useState(false);
  const [DEBTopen, setDEBTOpen] = useState(false);

  //const toggleDropdown = () => setOpen(!open); // Toggle dropdown visibility
  const preventClose = (e) => e.stopPropagation();



  const hideMessage = () => {
    setMessageType(null);
  };

  // Error Message

  const renderMessage = () => {
    if (messageType) {
      setTimeout(hideMessage, 5000);
    };

    switch (messageType) {
      case 'success':
        return (
          <Message type="success" closable style={{ display: 'flex', alignItems: 'center', width: 'auto', position: 'absolute', right: 0, top: 10, zIndex: 999 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
              <div className='icon_error_msg Icon_success'>
                <div className='icon_error_msg_inner Icon_success_inner'>
                  <img src={IconCheckError} alt="Success Icon" />
                  <div className="progress-circle progress_circle_success"></div>
                </div>
              </div>
              <div className='error_msg_text error_msg_success_text'>
                <h5>Success</h5>
                <p>{errorMessage}</p>
              </div>
            </div>
          </Message>
        );
      case 'error':
        return (
          <Message type="error" closable style={{ display: 'flex', alignItems: 'center', width: 'auto', position: 'absolute', right: 0, top: 10, zIndex: 999 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
              <div className='icon_error_msg Icon_error'>
                <div className='icon_error_msg_inner Icon_error_inner'>
                  <img src={IconError} alt="Error Icon" />
                  <div className="progress-circle progress_circle_error"></div>
                </div>
              </div>
              <div className='error_msg_text error_msg_error_text'>
                <h5>Error</h5>
                <p>{errorMessage}</p>
              </div>
            </div>
          </Message>
        );
      case 'info':
        return (
          <Message type="info" closable style={{ display: 'flex', alignItems: 'center', width: 'auto', position: 'absolute', right: 0, top: 10 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
              <div className='icon_error_msg Icon_info'>
                <div className='icon_error_msg_inner Icon_info_inner'>
                  <img src={IconInfo} alt="Info Icon" />
                  <div className="progress-circle progress_circle_info"></div>
                </div>
              </div>
              <div className='error_msg_text error_msg_info_text'>
                <h5>Info</h5>
                <p>{errorMessage}</p>
              </div>
            </div>
          </Message>
        );
      default:
        return null;
    }
  };



  // MODAL
  const [filterDate, setFilterDate] = useState(null);
  const [EditModalOpen, setEditModalOpen] = useState(false);
  const [editModalETFName, setEditModalETFName] = useState("");
  const [editModalETFSymbol, setEditModalSymbol] = useState("");
  const etfModelCommentRef = useRef(null);
  const [etfModelPublicComment, setEtfModelPublicComment] = useState("");
  const [etfModelPrivateComment, setEtfModelPrivateComment] = useState("");
  const [isModalETFLoading, setIsModalETFLoading] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(0);

  const handleEditModalOpen = (item) => {
    setEditModalETFName(item.ETF_Name);
    setEditModalSymbol(item.Symbol);

    if (item.is_manual_set === "1") {
      setSelectedStatus(item.Compliance_status);
      // Update the textarea's value
      setEtfModelPublicComment(item.manual_public_msg || "");
      setEtfModelPrivateComment(item.is_manual_set_msg || "");
    }
    else {
      setSelectedStatus("");
      setEtfModelPublicComment(""); // Clear the comment if not manual set
      setEtfModelPrivateComment("");
    }

    setEditModalOpen(true);
  }
  const handleEditModalClose = () => setEditModalOpen(false);

  // const StatusData = ['Compliant', 'Non- Compliant', 'Doubtful', 'Uncovered'].map(
  //     item => ({ label: item, value: item })
  // );
  const StatusData = ['Zain Shaikh', 'Sana Rizvi', 'Ali Noor', 'Rehan Qureshi', 'Nida Sheikh'].map(item => ({ label: item, value: { 'Compliant': 'COMPLIANT', 'Non- Compliant': 'NON_COMPLIANT', 'Doubtful': 'QUESTIONABLE', 'Uncovered': 'NOT_UNDER_COVERAGE' }[item] }));

  const CountryData = ['India', 'Saudi Arabia', 'USA', 'UAE', 'Pakistan'].map(item => ({ label: item, value: item }));

  const MembersData = ['Zain Shaikh', 'Sana Rizvi', 'Ali Noor', 'Rehan Qureshi', 'Nida Sheikh'].map(item => ({ label: item, value: item }));

  const InvestmentAmountData = [
    '$1,000',
    '$2,500',
    '$5,000',
    '$10,000'
  ].map(item => ({ label: item, value: item }));

  const SharesData = [
    '0 - 100',
    '101 - 500',
    '501 - 1,000'
  ].map(item => ({ label: item, value: item }));

  const InvestorTypeData = ['Confirmed', 'Pending', 'In Process', 'Cancelled'].map(item => ({ label: item, value: item }));

  const InvestorTypeData1 = ['Reg CF', 'Reg A+', '506(b)', '506(c)'].map(item => ({ label: item, value: item }));



  const StatusData1 = ['Committed', 'Funded', 'Interest Express', 'Cancelled', 'Completed'].map(item => ({ label: item, value: item }));


  useEffect(() => {
    if (etfModelCommentRef.current) {
      etfModelCommentRef.current.value = etfModelPublicComment;
    }
  }, [etfModelPublicComment]);



  const handleManualSave = async () => {

    if (!selectedStatus) {
      setErrorMessage('Please select new compliance status');
      setMessageType('error');
      return false;
    }

    if (!etfModelPrivateComment) {
      setErrorMessage('Please add a Private comment before submitting.');
      setMessageType('error');
      return false;
    }




  };

  const handleManualReset = async () => {


    setIsModalETFLoading(true);


  };

  const handleFilterDateChange = (value) => {
    setCurrentPage(1);


    setFilterDate(value);
  };



  const handleETFStatusChange = (selectedOption) => {
    setSelectedStatus(selectedOption); // Update selectedPeriod state with the selected option
  };

  const triggerRef = React.useRef();
  const openUncovered = () => triggerRef.current.openUncovered();
  const closeUncovered = () => triggerRef.current.closeUncovered();

  return (
    <>
      <Sidebar />
      <div id='header'>
        {renderMessage()}
        <div className='logo'>
          <div className='logo_icon'>
            <img src={Logo} />
          </div>
          <div className='brand_name'>Investment Transaction<small>(WL-000021)</small></div>
        </div>

        <div className='header_table_filter'>
          <div className='searchfield'>
            <button className='btn_search'><i className='icon-search2'></i></button>
            <input type='text' className='filter_searchfield' placeholder='Search' onChange={handleSearch} value={searchInput} />
          </div>



          <div className='dropdown_col_filter dropdown__select'>
            <SelectPicker
              data={InvestmentAmountData}
              searchable={false}
              style={{ width: 180 }}
              placeholder="Select Investments"
              onChange={handleStatusChange}
              value={statusId}
            />
          </div>

          <div className='dropdown_col_filter dropdown__select'>
            <SelectPicker
              data={InvestorTypeData}
              searchable={false}
              style={{ width: 180 }}
              placeholder="Select Status"
              onChange={handleCBAChange}
              value={cbaStatus}
            />
          </div>

          <div className='dropdown_col_filter dropdown__select'>
            <SelectPicker
              data={InvestorTypeData1}
              searchable={false}
              style={{ width: 180 }}
              placeholder="Select Type"
              onChange={handleCBAChange}
              value={cbaStatus}
            />
          </div>

          <div className='dropdown_col_filter dropdown__select'>
            <DatePicker
              oneTap
              style={{ width: 160 }}
              placeholder="Choose Date"
              format="dd-MM-yyyy"
              value={filterDate}
              onChange={handleFilterDateChange}
            />
          </div>



          {/* <div className='dropdown_style'>
                <SelectPicker
                    data={data}
                    searchable={false}
                    style={{ }}
                    placeholder="All Compliance statuses"
                    />
            </div>
            <div className='dropdown_style'>
                <SelectPicker
                    data={data}
                    searchable={false}
                    style={{ }}
                    placeholder="Both Publish Statuses"
                    />
            </div> */}

          <a href='javascript:void(0)' className="btn_clear_filter" style={{ textDecoration: "none" }} onClick={handleClearFilters}>Clear Filters</a>
        </div>
      </div>
      <div className="container-fluid content pb-5">
        <div className='company_table_list' data-aos="fade-up" data-aos-duration="800">

          {isLoading && (<Placeholder.Grid rows={20} columns={9} active style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 12 }} />)}

          {/* Table */}
          {!isLoading && (
            <>
              <div className='table-responsive clsPagingWrap'>
                <table className='table'>
                  <thead>
                    <tr>
                      <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Date of Investment</Tooltip>}>
                        <th>Investment Date</th>
                      </Whisper>

                      <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Investment Round Name</Tooltip>}>
                        <th>Round</th>
                      </Whisper>

                      <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Investment Amount</Tooltip>}>
                        <th style={{ textAlign: 'center' }}>Investment</th>
                      </Whisper>

                      <th style={{ textAlign: 'center' }}>Currency</th>

                      <th style={{ textAlign: 'center' }}>Share Price</th>
                      <th style={{ textAlign: 'center' }}>Shares Issued</th>

                      <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Bonus Shares</Tooltip>}>
                        <th style={{ textAlign: 'center' }}>Bonus</th>
                      </Whisper>


                      <th style={{ textAlign: 'center' }}>Ownership %</th>
                      <th style={{ textAlign: 'center' }}>Status</th>
                      <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Source of Investment</Tooltip>}>
                        <th>Source</th>
                      </Whisper>

                      <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Regulation Type</Tooltip>}>
                        <th>Type</th>
                      </Whisper>

                      <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Investment Notes</Tooltip>}>
                        <th>Notes</th>
                      </Whisper>

                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>22-May-2025</td>
                      <td><Link to={`/InvestDetails/`} className='etf_name text_ellipsis'>Seed 2025</Link></td>
                      <td style={{ textAlign: 'center', fontWeight: 600 }}>$10,000</td>
                      <td style={{ textAlign: 'center' }}>USD</td>
                      <td style={{ textAlign: 'center', fontWeight: 600 }}>$1.00</td>
                      <td style={{ textAlign: 'center', fontWeight: 600 }}>10,000</td>
                      <td style={{ textAlign: 'center', fontWeight: 600 }}>250</td>
                      <td style={{ textAlign: 'center' }}>5%</td>
                      <td><span className='tag_td halal_tag'>Confirmed</span></td>
                      <td>Platform</td>
                      <td>Reg CF</td>
                      <td>Webinar attendee, HNW</td>
                    </tr>


                    <tr>
                      <td>15-Apr-2025</td>
                      <td><Link to={`/InvestDetails/`} className='etf_name text_ellipsis'>Growth 2024</Link></td>
                      <td style={{ textAlign: 'center', fontWeight: 600 }}>$15,000</td>
                      <td style={{ textAlign: 'center' }}>AED</td>
                      <td style={{ textAlign: 'center', fontWeight: 600 }}>$1.50</td>
                      <td style={{ textAlign: 'center', fontWeight: 600 }}>10,000</td>
                      <td style={{ textAlign: 'center', fontWeight: 600 }}>300</td>
                      <td style={{ textAlign: 'center' }}>6.2%</td>
                      <td><span className='tag_td doughtful_tag'>Pending</span></td>
                      <td>Referral</td>
                      <td>Reg A+</td>
                      <td>Returning investor</td>
                    </tr>
                    <tr>
                      <td>08-Jan-2025</td>
                      <td><Link to={`/InvestDetails/`} className='etf_name text_ellipsis'>Seed 2025</Link></td>
                      <td style={{ textAlign: 'center', fontWeight: 600 }}>$5,000</td>
                      <td style={{ textAlign: 'center' }}>EUR</td>
                      <td style={{ textAlign: 'center', fontWeight: 600 }}>$1.25</td>
                      <td style={{ textAlign: 'center', fontWeight: 600 }}>4,000</td>
                      <td style={{ textAlign: 'center', fontWeight: 600 }}>150</td>
                      <td style={{ textAlign: 'center' }}>2.3%</td>
                      <td><span className='tag_td halal_tag'>Confirmed</span></td>
                      <td>Direct</td>
                      <td>506(b)</td>
                      <td>Event signup</td>
                    </tr>
                   
                 
                  
                    <tr>
                      <td>23-Oct-2025</td>
                      <td><Link to={`/InvestDetails/`} className='etf_name text_ellipsis'>Growth 2024</Link></td>
                      <td style={{ textAlign: 'center', fontWeight: 600 }}>$7,200</td>
                      <td style={{ textAlign: 'center' }}>USD</td>
                      <td style={{ textAlign: 'center', fontWeight: 600 }}>$1.20</td>
                      <td style={{ textAlign: 'center', fontWeight: 600 }}>6,000</td>
                      <td style={{ textAlign: 'center', fontWeight: 600 }}>140</td>
                      <td style={{ textAlign: 'center' }}>2.8%</td>
                      <td><span className='tag_td halal_tag'>Confirmed</span></td>
                      <td>Direct</td>
                      <td>Reg A+</td>
                      <td>Referred by founder</td>
                    </tr>

                  </tbody>
                </table>

              </div>
              {reportCount > 1 && renderPagination()}
            </>
          )}
        </div>
      </div>

      <Modal open={EditModalOpen} onClose={handleEditModalClose} className="edit_status_modal">
        <Modal.Header className="edit_modal_header">
          <Modal.Title className="edit_modal_title">{editModalETFName}</Modal.Title>
          <p>Re-Assign User</p>
        </Modal.Header>

        <Modal.Body>
          <div className="edit_modal_content">
            <div className="edit_status_field">
              <label>Select Sales User</label>
              <div className="select_edit_status">
                <SelectPicker
                  data={StatusData}
                  searchable={false}
                  style={{ width: '100%' }}
                  placeholder="Select members"
                  onChange={handleETFStatusChange} // Attach onChange event handler
                  value={selectedStatus} // Set the value prop to control the selected value
                />
              </div>
            </div>

            <div className="edit_status_field mt-4">
              <label>Comment
                <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Please mention the reason for reassigning the task. Ensure the content is clear and concise</Tooltip>}>
                  <img src={Icon_info} />
                </Whisper>
              </label>
              <textarea row="3" className="form-control"
                value={etfModelPublicComment}
                onChange={(e) => setEtfModelPublicComment(e.target.value)}></textarea>
            </div>

          </div>
        </Modal.Body>
        <Modal.Footer className="modal_footer_edit_status">
          <div className="btn__group">
            <button type="button" className="btn_cancel" onClick={handleEditModalClose}>Cancel</button>
            <Button className="btn___reset" onClick={handleManualReset} loading={isModalETFLoading}>Reset</Button>
            <button className="btn__save" onClick={handleManualSave}>Save</button>
          </div>
        </Modal.Footer>
      </Modal>

    </>
  );
}

export default InvestmentList;
